var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-1"},[(_vm.prop != null)?_c('v-row',{staticClass:"ma-0 mx-2"},[_c('div',{staticClass:"ma-0 pa-0 pl-2 section-item-title"},[_c('p',{staticClass:"ma-0 pa-0"},[_vm._v(_vm._s(_vm.prop))])])]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }